import React, { Component } from "react";
import Header from "../../Components/MainLayout/Header";
import { connect } from "react-redux";
import LiveClassCard from "../../Components/LiveClass/LiveClassCard";

const mapStateToProps = ({ dispatch, user }) => ({
  dispatch,
  user,
});

class LiveClass extends Component {
  state = {};
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div>
        <Header title="Live Class" />
        <div className="container pt-3">
          <LiveClassCard />
        </div>
      </div>
    );
  }
}
export default connect(mapStateToProps)(LiveClass);
